import { render, staticRenderFns } from "./evenements.vue?vue&type=template&id=518c3b79&"
import script from "./evenements.vue?vue&type=script&lang=js&"
export * from "./evenements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports